import { Empty } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoDataEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t('common.noData')}
    />
  );
};

export default NoDataEmpty;
